import { type FC } from "react";
import { SectionTitle } from "@userFrontend/components/SectionTitle";
import { SectionWithTitleAndLabel } from "@userFrontend/components/SectionWithTitleAndLabel";
import { commonInner } from "@userFrontend/features/clientReview/components/ClientReviewInputs/styles.css";
import { ClientSelect } from "./uiParts/ClientSelect";
import { EntryClientSelect } from "./uiParts/EntryClientSelect";
import * as styles from "./styles.css";
import { type Props } from "./type";

export const ClientSelectSection: FC<Props> = ({
  client,
  clientShop,
  clientRef,
  handleShowModal,
  clientErrorText,
  isShowSearchModal,
  handleCloseModal,
  clientNameValue,
  shopNameValue,
  clientNameErrorText,
  shopNameErrorText,
  handleClientSearch,
  handleChangeClientNameValue,
  handleChangeShopNameValue,
  searchResults,
  handleClientSelect,
  isShowClientsDetail,
  handleShowTextButton,
  tooManyResultErrorText,
  noResultError,
  displaySearchText,
  isSearching,
  handleReturnToMyPageTop,
  userContactPath,
  checkedJobEntryId,
  jobEntryButtons,
  title,
  subtitle,
  isShowAnnotation = true,
}) => (
  <>
    <SectionTitle text={title} />
    <div className={commonInner}>
      <div className={styles.inputOuter}>
        <SectionWithTitleAndLabel isRequired title={subtitle} containerRef={clientRef}>
          {jobEntryButtons?.length ? (
            <EntryClientSelect
              isShowAnnotation={isShowAnnotation}
              client={client}
              clientShop={clientShop}
              handleShowModal={handleShowModal}
              isShowSearchModal={isShowSearchModal}
              handleCloseModal={handleCloseModal}
              clientNameValue={clientNameValue}
              shopNameValue={shopNameValue}
              clientNameErrorText={clientNameErrorText}
              shopNameErrorText={shopNameErrorText}
              handleClientSearch={handleClientSearch}
              handleChangeClientNameValue={handleChangeClientNameValue}
              handleChangeShopNameValue={handleChangeShopNameValue}
              searchResults={searchResults}
              handleClientSelect={handleClientSelect}
              isShowClientsDetail={isShowClientsDetail}
              handleShowTextButton={handleShowTextButton}
              tooManyResultErrorText={tooManyResultErrorText}
              noResultError={noResultError}
              displaySearchText={displaySearchText}
              isSearching={isSearching}
              handleReturnToMyPageTop={handleReturnToMyPageTop}
              userContactPath={userContactPath}
              checkedJobEntryId={checkedJobEntryId}
              jobEntryButtons={jobEntryButtons}
              clientErrorText={clientErrorText}
            />
          ) : (
            <ClientSelect
              isShowAnnotation={isShowAnnotation}
              client={client}
              clientShop={clientShop}
              clientErrorText={clientErrorText}
              handleShowModal={handleShowModal}
              isShowSearchModal={isShowSearchModal}
              handleCloseModal={handleCloseModal}
              clientNameValue={clientNameValue}
              shopNameValue={shopNameValue}
              clientNameErrorText={clientNameErrorText}
              shopNameErrorText={shopNameErrorText}
              handleClientSearch={handleClientSearch}
              handleChangeClientNameValue={handleChangeClientNameValue}
              handleChangeShopNameValue={handleChangeShopNameValue}
              searchResults={searchResults}
              handleClientSelect={handleClientSelect}
              isShowClientsDetail={isShowClientsDetail}
              handleShowTextButton={handleShowTextButton}
              tooManyResultErrorText={tooManyResultErrorText}
              noResultError={noResultError}
              displaySearchText={displaySearchText}
              isSearching={isSearching}
              handleReturnToMyPageTop={handleReturnToMyPageTop}
              userContactPath={userContactPath}
            />
          )}
        </SectionWithTitleAndLabel>
      </div>
    </div>
  </>
);
